import React, { useMemo } from "react";
import Modal from "react-modal";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import detailTabSwitchService from "../DetailTabSwitchService";
import ProductErrorReportModal from "./ProductErrorReportModal";

interface DescriptionDetailModalProperties {
    readonly productDetailInfo: ProductDetailInfo;
    readonly onAfterClose: () => void;
}

export default function ProductDescriptionDetailModal({ productDetailInfo, onAfterClose }: DescriptionDetailModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(true);

    const externalHTML = useMemo<string>((): string => {
        const externalElement = document.querySelector<HTMLDivElement>("#js-product-description-detail-container");

        return externalElement?.innerHTML ?? "";
    }, []);

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    const handleGoToVariants = (): void => {
        detailTabSwitchService.switchAndScrollToVariantsTab();
        closeModal();
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            onAfterClose={onAfterClose}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop modal-transition shop-modal-change"
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="row">
                        <div className="col-xs-12 product-description">
                            {productDetailInfo.quantity > 0
                              && <p className="switch-to-variant-note">
                                  <i className="fa-solid fa-info-circle"></i>Pro zobrazení stavu a kompletnosti jednotlivých variant přepněte na kartu <a
                                      className="cursor-pointer" onClick={handleGoToVariants}>Porovnání variant
                                  </a>.
                              </p>}

                            <div dangerouslySetInnerHTML={{ __html: externalHTML }}></div>

                            <ProductErrorReportModal productDetailInfo={productDetailInfo} />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
